// Resource
import { PlanCreationSourceKind } from "./IGraphPlanCreationSourceResource";
/**
 * Checks if the given resource is a GraphPlanCreationSourceResource
 * @param resource The resource to check
 * @returns True if the resource is a GraphPlanCreationSourceResource
 */ export function isGraphExternalPlanResource(resource) {
    return resource.creationSourceKind === PlanCreationSourceKind.External;
}
